// extracted by mini-css-extract-plugin
export var page_header_category = "page-header-category-module--page_header_category--2x903";
export var page_header_category__head_text = "page-header-category-module--page_header_category__head_text--3etDF";
export var page_header_category__text = "page-header-category-module--page_header_category__text--MndCn";
export var page_header_category__lead = "page-header-category-module--page_header_category__lead--1ecEk";